import { CodeSection, CodeSubject } from 'civil-status/constants/code-subject-section';
import { ParentVM, SectionVM } from 'civil-status/view-models/step-form';
import { FormikErrors } from 'formik';
import { CivilStatusID } from 'shell/constants/civil-status';
import { SubjectsWizardUseCase } from 'shell/models/subjects-wizard';

export const formStepWithErrors = (
  errors: FormikErrors<unknown>,
  isWith1Comparente: boolean,
  isWith2Comparente: boolean,
  valuesDeceduto?: ParentVM,
  valuesDatiGeneraliRiconoscimento?: SectionVM,
  soggettiUsecaseData?: Array<SubjectsWizardUseCase>
): boolean => {
  const keysErrors = Object.keys(errors || {});

  // Definire una funzione di utilità per controllare se un soggetto è presente nei dati dell'uso del caso
  const isSubjectPresent = (subjectCode: string) =>
    Boolean(soggettiUsecaseData?.find((itemSogg) => itemSogg.codSoggetto === subjectCode));

  // Verificare se un determinato codice di stato civile è presente nei valori del defunto
  const isCivilStatusPresent = (civilStatusId: string) =>
    valuesDeceduto?.generality?.civilStatusItem?.id?.toString() === civilStatusId;

  if (
    keysErrors.some((item) => {
      if (item.includes(CodeSubject.COMPARENTE1)) {
        return isWith1Comparente || isWith2Comparente;
      }

      if (item.includes(CodeSubject.COMPARENTE2)) {
        return isWith2Comparente;
      }

      if (item.includes(CodeSubject.CONIUGE)) {
        return (
          isSubjectPresent(CodeSubject.DECEDUTO) &&
          (isCivilStatusPresent(CivilStatusID.coniugato) ||
            isCivilStatusPresent(CivilStatusID.vedovo))
        );
      }

      if (item.includes(CodeSubject.UNITOCIVILMENTE)) {
        return (
          isCivilStatusPresent(CivilStatusID.unitoCivilmente) ||
          isCivilStatusPresent(CivilStatusID.scioglimentoUnitoCivilmenteASeguitoDelDecesso)
        );
      }

      if (item.includes(CodeSection.AUTORIZZAZIONE_RICONOSCIMENTO_PADRE)) {
        return valuesDatiGeneraliRiconoscimento?.isIncestuousSonSentence || false;
      }

      return true;
    })
  ) {
    return true;
  }

  return false;
};
